import { Component, OnInit } from '@angular/core';
import { ModalContainerService, BaseModalUpdateComponent, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Dokument } from './dokument';

@Component({
  selector: 'yt-dokument-modal-update',
  templateUrl: './dokument-modal-update.component.html'
})
export class DokumentModalUpdateComponent extends BaseModalUpdateComponent<Dokument>{

  constructor(
    protected modalContainerService: ModalContainerService<Dokument>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService

  ) { 
    super(modalContainerService, activeModal,modalService);
  }



}
